import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './importlead.css';
import Sidebar from '../Sidebar/Sidebar';
import '@fortawesome/fontawesome-free/css/all.min.css';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { useNavigate } from 'react-router-dom';
import { RingLoader } from 'react-spinners'; // Import RingLoader here
import $, { data } from 'jquery';
import '../pages.css';
const FileUploadComponent = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [builderTypes, setBuilderTypes] = useState([]);
  const [selectedBuilderType, setSelectedBuilderType] = useState('');
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      $('#loading').show();
      try {
        const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  
        if (!accessToken) {
          navigate('/');
          console.error('Access token not found in localStorage');
          $('#loading').hide();
          return;
        }
  
        const response = await fetch(`${baseURL}/get_ads/`, {
          headers: {
            Authorization: `Token ${accessToken}`,
            'Cache-Control': 'no-cache', // Include access token in the headers
          },
        });
  
        if (!response.ok) {
          $('#loading').hide();
        }
  
        const data = await response.json();
        if (data && data.data) {
          setBuilderTypes(data.data);
          $('#loading').hide();

        }
      } catch (error) {
        console.error('Error fetching builder types:', error);
        setErrors({ selectedBuilderType: 'Error fetching builder types' });
        $('#loading').hide();

      }
    };
  
    fetchData();
  }, []);
  

  const handleUploadClick = () => {
    document.getElementById('call-to-action').classList.add('upload--loading');

    // Detect file dialog cancel — window regains focus without a file being chosen
    const handleWindowFocus = () => {
      setTimeout(() => {
        const input = document.querySelector('.upload-hidden');
        if (!input || !input.files || input.files.length === 0) {
          const cta = document.getElementById('call-to-action');
          if (cta) cta.classList.remove('upload--loading');
        }
        window.removeEventListener('focus', handleWindowFocus);
      }, 300);
    };
    window.addEventListener('focus', handleWindowFocus);

    document.querySelector('.upload-hidden').click();
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setIsLoading(true); // Show spinner when file upload begins

    const formData = new FormData();
    formData.append('selectedBuilderType', selectedBuilderType);
    formData.append('file', file);
    $('#loading').show();

    fetch(`${baseURL}/import_leads/`, {
      method: 'POST',
      headers: {
        Authorization: `Token ${localStorage.getItem('access_token') || sessionStorage.getItem('access_token')}`,
        'Cache-Control': 'no-cache', // Include access token in the headers
      },
      body: formData,
    })
      .then((response) => {
        $('#loading').hide();
        if (response.ok) {
          
          toastr.success('File uploaded successfully!');
          document.getElementById('call-to-action').classList.remove('upload--loading');
          setSelectedFile(null);
          setSelectedBuilderType('');
          $('#loading').hide();
          
        } else {
          toastr.error('Error uploading file.');
          document.getElementById('call-to-action').classList.remove('upload--loading');
          setSelectedFile(null);
          $('#loading').hide();
        }
      })
      .catch((error) => {
        document.getElementById('call-to-action').classList.remove('upload--loading');
          setSelectedFile(null);
        
        toastr.error('Error:', error.message);
        $('#loading').hide();
      });
  };

  const handleBuilderTypeChange = (event) => {
    setSelectedBuilderType(event.target.value);
  };

  return (
    <div className="container-fluid tms-page">
      <div id="loading">
        <div className="loader">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="loader-text">Loading...</div>
        </div>
      </div>
      <div className="row flex-nowrap">
        <div className="col-auto p-0"><Sidebar /></div>
        <main className="tms-main">
          <div className="tms-page-header">
            <div>
              <h2 className="tms-page-title">Import Leads</h2>
              <div className="tms-page-subtitle">Upload lead files to TMS server</div>
            </div>
          </div>

          <div className="tms-card" style={{ maxWidth: 600 }}>
            <div className="tms-form-group">
              <label className="tms-label">Select Ad</label>
              <select
                aria-label="Select Builder Type"
                className={`tms-select${errors.selectedBuilderType ? ' tms-input-error' : ''}`}
                value={selectedBuilderType}
                onChange={handleBuilderTypeChange}
              >
                <option value="">Select Builder Type</option>
                {Array.isArray(builderTypes) &&
                  builderTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.builder_name}
                    </option>
                  ))}
              </select>
              {errors.selectedBuilderType && <div className="tms-error">{errors.selectedBuilderType}</div>}
            </div>

            <div id="call-to-action" className="tms-upload-zone" onClick={handleUploadClick}>
              <div className="tms-upload-icon">☁️</div>
              <div className="tms-upload-text">Upload Your Files To TMS Server</div>
              <div className="tms-upload-sub">Click to browse and select your file</div>
            </div>
            <form id="upload" method="post" action="upload.php" encType="multipart/form-data">
              <div id="drop"><input type="file" name="upl" multiple className="upload-hidden" onChange={handleFileInputChange} /></div>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default FileUploadComponent;
